import { render, staticRenderFns } from "./ItsSalesInner.vue?vue&type=template&id=8b106df8&scoped=true&"
import script from "./ItsSalesInner.vue?vue&type=script&lang=js&"
export * from "./ItsSalesInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b106df8",
  null
  
)

export default component.exports